/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganization400Response,
  ExportDsfinvKReport400Response,
  GetLegalEntityAvailableTypes200ResponseInner,
  GetLegalEntityCertificate200Response,
  UpdateLegalEntityPaymentMethodRequest,
  ValidateLegalEntity200Response,
  ValidateLegalEntityRequest,
} from '../models/index';
import {
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    ExportDsfinvKReport400ResponseFromJSON,
    ExportDsfinvKReport400ResponseToJSON,
    GetLegalEntityAvailableTypes200ResponseInnerFromJSON,
    GetLegalEntityAvailableTypes200ResponseInnerToJSON,
    GetLegalEntityCertificate200ResponseFromJSON,
    GetLegalEntityCertificate200ResponseToJSON,
    UpdateLegalEntityPaymentMethodRequestFromJSON,
    UpdateLegalEntityPaymentMethodRequestToJSON,
    ValidateLegalEntity200ResponseFromJSON,
    ValidateLegalEntity200ResponseToJSON,
    ValidateLegalEntityRequestFromJSON,
    ValidateLegalEntityRequestToJSON,
} from '../models/index';

export interface CanDisableVerifactuRequest {
    legalEntityId: string;
}

export interface DeleteLegalEntityCertificateRequest {
    legalEntityId: string;
}

export interface DisableVerifactuRequest {
    legalEntityId: string;
}

export interface EnableVerifactuRequest {
    legalEntityId: string;
}

export interface GetLegalEntityAvailableTypesRequest {
    legalEntityId: string;
}

export interface GetLegalEntityAvailableTypesByCountryCodeRequest {
    countryCode: string;
}

export interface GetLegalEntityCertificateRequest {
    legalEntityId: string;
}

export interface IsVerifactuEnabledRequest {
    legalEntityId: string;
}

export interface UpdateLegalEntityPaymentMethodOperationRequest {
    legalEntityId: string;
    updateLegalEntityPaymentMethodRequest: UpdateLegalEntityPaymentMethodRequest;
}

export interface UploadLegalEntityCertificateRequest {
    legalEntityId: string;
}

export interface ValidateLegalEntityOperationRequest {
    validateLegalEntityRequest: ValidateLegalEntityRequest;
}

/**
 * 
 */
export class LegalEntitiesApi extends runtime.BaseAPI {

    /**
     */
    async canDisableVerifactuRaw(requestParameters: CanDisableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling canDisableVerifactu().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/verifactu/can-disable`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async canDisableVerifactu(requestParameters: CanDisableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.canDisableVerifactuRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteLegalEntityCertificateRaw(requestParameters: DeleteLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling deleteLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLegalEntityCertificate(requestParameters: DeleteLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLegalEntityCertificateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async disableVerifactuRaw(requestParameters: DisableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling disableVerifactu().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/verifactu/disable`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableVerifactu(requestParameters: DisableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableVerifactuRaw(requestParameters, initOverrides);
    }

    /**
     */
    async enableVerifactuRaw(requestParameters: EnableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling enableVerifactu().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/verifactu/enable`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableVerifactu(requestParameters: EnableVerifactuRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableVerifactuRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getLegalEntityAvailableTypesRaw(requestParameters: GetLegalEntityAvailableTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLegalEntityAvailableTypes200ResponseInner>>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalEntityAvailableTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/available-types`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLegalEntityAvailableTypes200ResponseInnerFromJSON));
    }

    /**
     */
    async getLegalEntityAvailableTypes(requestParameters: GetLegalEntityAvailableTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLegalEntityAvailableTypes200ResponseInner>> {
        const response = await this.getLegalEntityAvailableTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLegalEntityAvailableTypesByCountryCodeRaw(requestParameters: GetLegalEntityAvailableTypesByCountryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetLegalEntityAvailableTypes200ResponseInner>>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getLegalEntityAvailableTypesByCountryCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/available-types/{countryCode}`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLegalEntityAvailableTypes200ResponseInnerFromJSON));
    }

    /**
     */
    async getLegalEntityAvailableTypesByCountryCode(requestParameters: GetLegalEntityAvailableTypesByCountryCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetLegalEntityAvailableTypes200ResponseInner>> {
        const response = await this.getLegalEntityAvailableTypesByCountryCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLegalEntityCertificateRaw(requestParameters: GetLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLegalEntityCertificate200Response>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLegalEntityCertificate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getLegalEntityCertificate(requestParameters: GetLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLegalEntityCertificate200Response> {
        const response = await this.getLegalEntityCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async isVerifactuEnabledRaw(requestParameters: IsVerifactuEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling isVerifactuEnabled().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/verifactu/is-enabled`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async isVerifactuEnabled(requestParameters: IsVerifactuEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.isVerifactuEnabledRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateLegalEntityPaymentMethodRaw(requestParameters: UpdateLegalEntityPaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling updateLegalEntityPaymentMethod().'
            );
        }

        if (requestParameters['updateLegalEntityPaymentMethodRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLegalEntityPaymentMethodRequest',
                'Required parameter "updateLegalEntityPaymentMethodRequest" was null or undefined when calling updateLegalEntityPaymentMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/payment-method`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLegalEntityPaymentMethodRequestToJSON(requestParameters['updateLegalEntityPaymentMethodRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateLegalEntityPaymentMethod(requestParameters: UpdateLegalEntityPaymentMethodOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLegalEntityPaymentMethodRaw(requestParameters, initOverrides);
    }

    /**
     */
    async uploadLegalEntityCertificateRaw(requestParameters: UploadLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLegalEntityCertificate200Response>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling uploadLegalEntityCertificate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/legal-entities/{legalEntityId}/certificates`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLegalEntityCertificate200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async uploadLegalEntityCertificate(requestParameters: UploadLegalEntityCertificateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLegalEntityCertificate200Response> {
        const response = await this.uploadLegalEntityCertificateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validateLegalEntityRaw(requestParameters: ValidateLegalEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateLegalEntity200Response>> {
        if (requestParameters['validateLegalEntityRequest'] == null) {
            throw new runtime.RequiredError(
                'validateLegalEntityRequest',
                'Required parameter "validateLegalEntityRequest" was null or undefined when calling validateLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/legal-entities/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateLegalEntityRequestToJSON(requestParameters['validateLegalEntityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateLegalEntity200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async validateLegalEntity(requestParameters: ValidateLegalEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateLegalEntity200Response> {
        const response = await this.validateLegalEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
